import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NiosAllClass = () => {
  const [niosClassName, setNiosClassName] = useState([]);

  const navigate = useNavigate();

  const handleAddNewClass = () => {
    navigate("/nios-add-class");
  };

  const handleViewAllClasses = () => {
    navigate("/nios-all-class");
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  // CLASSES DATA GET FUN AXIOS --
  const getClasses = () => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        // console.log(resp.data);

        setNiosClassName(resp.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    // alert("aa gya")
    getClasses();
  }, []);

  // API DELETE FUN
  let handleSchoolClassDlt = async (id) => {
    let dltOrNot = window.confirm("Do you want to delete");
    if (dltOrNot) {
      axios
        .delete(`${API_BASE_URL}/admin/niosClass/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((resp) => {
          console.log(resp);
          getClasses();
        });
    }
  };

  const handleEdit = (id) => {
    // alert(id);
    navigate(`/nios-edit-class/${id}`);
  };
  return (
    <>
      <div id="classes-inner-wrapper">
        <div className="classes-header-div">
          <h5>Nios Classes</h5>
          <div className="classes-header-btns">
            <button className="add-class-btn" onClick={handleAddNewClass}>
              + Add New Class
            </button>
            <button className="all-classes-btn" onClick={handleViewAllClasses}>
              All Classes
            </button>
          </div>
        </div>

        <div className="classes-table-container">
          <h5>All Nios Classes</h5>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Class</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {niosClassName &&
                niosClassName.map((classes, idx) => (
                  <tr key={classes._id}>
                    <td>{idx + 1}</td>
                    <td>{classes.className}</td>
                    <td className="table-action-icons">
                      <i
                        className="fa-solid fa-file-pen"
                        onClick={() => handleEdit(classes._id)}
                      ></i>
                      <i
                        className="fa-solid fa-trash-can"
                        onClick={() => handleSchoolClassDlt(classes._id)}
                      ></i>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default NiosAllClass;
